// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        mainPopupBannerId: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.mainPopupBannerId !== undefined)
        result.mainPopupBannerId = tsValueToJsonValueFns.int64(value.mainPopupBannerId);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.mainPopupBannerId !== undefined)
        result.mainPopupBannerId = jsonValueToTsValueFns.int64(value.mainPopupBannerId);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.mainPopupBannerId !== undefined) {
        const tsValue = value.mainPopupBannerId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.mainPopupBannerId = value;
    }
    return result;
}
